'use strict';exports.__esModule = true;exports.default =



generateCanonicalLink;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);var _formatCityName = require('../helpers/formatCityName');var _formatCityName2 = _interopRequireDefault(_formatCityName);var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function generateCanonicalLink(routeData) {
  var optionTypeParam = routeData.optionType ? '/' + routeData.optionType : '';
  var params = ['' + routeData.location + optionTypeParam];
  var cityName = (0, _get2.default)(routeData, 'locationSearch.en.city_name');
  var roomsData = (0, _get2.default)(routeData, 'params.rooms') || [];
  var propertyTypes = (0, _get2.default)(routeData, 'params.types') || [];

  var city = cityName ? (0, _formatCityName2.default)(cityName) : null;

  if (city) {
    params.push(city);
  }

  var rooms = roomsData.length > 0 ? 'rooms_' + roomsData.join(',') : null;

  if (rooms) {
    params.push(rooms);
  }

  var types = propertyTypes.length > 0 ? 'types_' + propertyTypes[0] : null;

  if (types) {
    params.push(types);
  }

  var locale = routeData.locale === _constants.language.default ? '' : routeData.locale + '/';

  return '/' + locale + params.join('/');
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/generateCanonicalLink.js
// module id = 3132
// module chunks = 0